export default ".async-label {\n  color: black;\n}\n\n.async-spinner {\n  margin-left: 15px;\n  display: inline-block;\n}";